import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ListFreelancersService {

  private freelancersCountSource = new Subject<{req: boolean, count: number}>();

  freelancersCountChanged$ = this.freelancersCountSource.asObservable();

  changeCount(req: boolean, count: number) {
    this.freelancersCountSource.next({req: req, count: count});
  }
}




// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/services/list-freelancers.service.ts